<style lang="scss">
.carousel {
    //background-color: theme('colors.white');

    @media (min-width: 768px) {
        background: none;
    }

    * {
        outline: none;
    }

    .tns-slider {
        display: flex;
        align-items: stretch;
    }

    button[data-action='stop'],
    button[data-action='start'] {
        display: none;
    }

    .tns-outer {
        position: relative;
        z-index: 2;
    }

    .tns-liveregion {
        display: none;
    }

    .tns-ovh,
    .tns-inner {
        overflow: visible;
    }

    .tns-item {
        overflow: hidden;
    }

    .tns-nav {
        height: 52px;
        bottom: 82px;
        left: 50%;
        display: none;
        position: absolute;
        z-index: 12;
        justify-content: flex-end;
        align-items: center;
        pointer-events: none;
        transform: translateX(-50%);
        width: calc(100% - 40px);
        margin-right: auto;
        margin-left: auto;

        button {
            width: 4px;
            height: 4px;
            padding: 0;
            margin: 0 4px;
            border-radius: 50%;
            background-color: #bdc0c8;
            pointer-events: all;
            border: 0;
            transition: background-color 0.2s;

            &:focus {
                outline: none;
                box-shadow: none;
            }

            &.tns-nav-active {
                background-color: #1b1c1f;
            }
        }

        @media (min-width: 576px) {
            max-width: calc(576px - 160px);
        }

        @media (min-width: 768px) {
            max-width: calc(768px - 80px);
            display: flex;
        }

        @media (min-width: 1024px) {
            max-width: calc(1024px - 80px);
        }

        @media (min-width: 1280px) {
            max-width: calc(1280px - 160px);
        }

        @media (min-width: 1440px) {
            max-width: calc(1440px - 304px);
        }
    }

    .controls {
        max-width: 1666px;
        height: 100%;
        top: 0;
        left: 50%;
        display: block;
        position: absolute;
        z-index: 10;
        align-items: center;
        pointer-events: none;
        transform: translateX(-50%);

        width: calc(100% - 40px);
        margin-right: auto;
        margin-left: auto;

        @media (min-width: 576px) {
            max-width: 576px;
        }

        @media (min-width: 768px) {
            max-width: 768px;
        }

        @media (min-width: 1024px) {
            max-width: 1024px;
        }

        @media (min-width: 1280px) {
            max-width: 1280px;
        }

        @media (min-width: 1440px) {
            max-width: 1440px;
        }

        @media (min-width: 1920px) {
            max-width: 1440px;
        }

        &:focus,
        &:active {
            outline: none;
        }

        .left,
        .right {
            opacity: 1;
            transition: opacity 0.2s, left 0.2s, width 0.2s, right 0.2s, transform 0.2s;
            width: 40px;
            height: 40px;
            cursor: pointer;
            position: absolute;
            top: 130px;
            background-repeat: no-repeat;
            background-size: 38px 44px;
            pointer-events: all;
            display: none;

            &:focus,
            &:active {
                outline: none;
            }

            @media screen and (min-width: 768px) {
                width: 80px;
                height: 80px;
            }

            @media screen and (min-width: 1024px) {
                display: block;
                top: 85px;
            }

            @media screen and (min-width: 1280px) {
                top: 130px;
            }

            &[aria-disabled='true'] {
                opacity: 0;
            }
        }

        .left {
            background-image: url('/svg/chevron-right-dark.svg');
            background-position: center;
            left: 84px;
            transform: rotate(180deg);
            display: none;

            &:hover {
                transform: rotate(180deg) scale(1.05);
            }
        }

        .right {
            background-image: url('/svg/chevron-right-dark.svg');
            background-position: center;
            right: 84px;

            &:hover {
                transform: scale(1.05);
            }
        }
    }
}
</style>

<template>
    <div class="carousel relative" v-if="ready">
        <tiny-slider ref="slider" :dots="true" :loop="true" :swipeAngle="30" :lazyload="false" :controls-container="`#customcontrols_${_uid}`" :rewind="false" :auto-width="false" :autoplay="autoplay" :fixed-width="false" :nav="true" :responsive="responsive">
            <slot></slot>
        </tiny-slider>

        <div :id="`customcontrols_${_uid}`" class="controls">
            <div ref="prev" class="left"></div>
            <div ref="next" class="right"></div>
        </div>
    </div>
</template>

<script>
import VueTinySlider from 'vue-tiny-slider';

export default {
    name: 'Ui.Carousel',

    components: { 'tiny-slider': VueTinySlider },

    props: {
        responsive: {
            type: [Object, Boolean],
            required: false,
            default: () => {
                return false;
            },
        },
    },

    data() {
        return {
            slider: null,
            autoplay: false,
            ready: false,
        };
    },

    mounted() {
        const self = this;

        if (window.innerWidth >= 768) {
            this.autoplay = true;
            //this.slider.play();
        } else {
            this.autoplay = false;
        }

        window.addEventListener('resize', () => {
            self.rebuildSlider();
        });

        window.addEventListener('orientationchange', () => {
            self.rebuildSlider();
        });

        this.ready = true;

        this.$nextTick(() => {
            this.slider = this.$refs.slider.slider;
        });
    },

    methods: {
        rebuildSlider() {
            this.slider.destroy();

            if (window.innerWidth >= 768) {
                this.autoplay = true;
            } else {
                this.autoplay = false;
            }

            this.slider = this.slider.rebuild();
            this.slider.play();
        },
    },
};
</script>
